import { Components, Theme } from '@mui/material'
import { palette } from '../palette'

declare module '@mui/material/FormControlLabel' {
  interface FormControlLabelProps {
    'data-is-ai-prefilled'?: boolean
  }
}

export const MuiFormControlLabel: Components<Omit<Theme, 'components'>>['MuiFormControlLabel'] = {
  styleOverrides: {
    label: {
      fontSize: 16,
    },
    root: ({ ownerState, 'data-is-ai-prefilled': dataIsAiPrefilled }) => ({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      padding: '2px 0',
      ...(ownerState.labelPlacement === 'top' && {
        alignItems: 'center',
        flexDirection: 'column-reverse',
        marginLeft: 16,
      }),
      ...(ownerState.labelPlacement === 'bottom' && {
        alignItems: 'center',
        flexDirection: 'column',
        marginLeft: 16,
      }),
      '&:not(.Mui-disabled) .MuiFormControlLabel-label': {
        backgroundColor: dataIsAiPrefilled ? palette.secondary.light : undefined,
      },
      color: palette.neutralDark[100],
      '.Mui-disabled': {
        '.MuiTypography-root': {
          color: ownerState.checked ? palette.neutralLight[900] : palette.neutralLight[700],
        },
      },
    }),
  },
}
